import { useState } from 'react'
import { Drawer } from 'antd'

import Box from '~/core/Box'

import DrawerTitle from './DrawerTitle'
import DrawerBody from './DrawerBody'
import DrawerFooter from './DrawerFooter'
import SubMenu from './SubMenu'

type OnBoardDrawerPropsType = {
    visible: boolean
    onClose: () => void
}

const WIDTH = 360
const NO_PADDING_STYLE = { padding: '0px' }

export const PLACEMENT = 'on-board-drawer'

export default function OnBoardDrawer(props: OnBoardDrawerPropsType) {
    const { visible, onClose } = props

    const [subMenuVisible, setSubMenuVisible] = useState(false)

    return (
        <Drawer
            bodyStyle={{ flex: 1, ...NO_PADDING_STYLE }}
            drawerStyle={{ display: 'flex', flexDirection: 'column' }}
            headerStyle={NO_PADDING_STYLE}
            onClose={onClose}
            title={
                <DrawerTitle
                    subMenuVisible={subMenuVisible}
                    onClick={() => setSubMenuVisible(false)}
                    onClose={onClose}
                />
            }
            width={WIDTH}
            visible={visible}
        >
            <Box direction="col" height="100%" justifyContent="between">
                {subMenuVisible ? (
                    <SubMenu />
                ) : (
                    <DrawerBody onClick={() => setSubMenuVisible(true)} />
                )}
                <DrawerFooter />
            </Box>
        </Drawer>
    )
}
